import { Component } from '@angular/core';

@Component({
  selector: 'app-page-cultura-colaborativa',
  templateUrl: './page-cultura-colaborativa.component.html',
  styleUrls: ['./page-cultura-colaborativa.component.scss'],
})
export class PageCulturaColaborativaComponent {}
